import { useDecision } from '@optimizely/react-sdk'
import { ReactNode } from 'react'

type AbVariationTestWrapperProps = {
  /**
   * The child components to render conditionally based on the variation key.
   */
  children: ReactNode

  /**
   * The flag used to determine the variation decision from Optimizely.
   */
  flag: string

  /**
   * The key that determines which variation to show or hide.
   */
  variationKey: string

  /**
   * Optional. If true, the children will be hidden when the variationKey matches.
   * @default false
   */
  hide?: boolean
}

export const AbVariationTestWrapper = ({
  children,
  flag,
  hide = false,
  variationKey,
}: AbVariationTestWrapperProps) => {
  const [decision] = useDecision(flag)

  const shouldRender = hide
    ? decision.variationKey !== variationKey
    : decision.variationKey === variationKey

  return shouldRender ? <>{children}</> : null
}

export default AbVariationTestWrapper
